var mm = new TimelineMax({paused: true});

let isAnimated = false;

var setMotion = function(){
    mm.addLabel('init')
        .from($('.maps_tit'), 0.84, {y: -15, alpha: 0, ease: Power3.easeOut}, "init+=0.8")
        .from($('.maps_txt'), 0.84, {y: 10, alpha: 0, ease: Power3.easeOut}, "init+=1.3")
        .from($('.map_wrap'), 0.84, {alpha: 0, ease: Power3.easeOut}, "init+=1.5");
};

var init = function(){
    $('[data-maplayer="open"]').on("click", function () {
        var idx = $(this).data('map');
        mapLayer("open", idx);
    });

    $('[data-maplayer="close"]').on("click", function () {
        var idx = $(this).data('map');
        mapLayer("close");
    });

    $(document).on('mouseover', '.map_wrap .btn-map button', function (e) {
        $('.map_wrap .map').removeClass('hover');
        let target = $(this).data('map');
        $('.'+ target).addClass('hover').siblings().addClass('dim');
    }).on('mouseout', '.map_wrap .btn-map button', function (e) {
        $('.map_wrap .map').removeClass('hover');
        $('.map_wrap .map').removeClass('dim');
    });
};
var settings = {
    spaceBetween: 30,
    effect: 'fade',
    simulateTouch: false,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop:true,
}
function mapLayer(stateChk, idx){
    if (stateChk == "open") {
        switch(idx){
            case 'map1':
                $("#layer_map_wrap").fadeIn();
                var con = $('.layer-map-1').clone(true);
                $('#mapBox').append(con);
                var swiper1 = new Swiper('#layer_map_wrap .sliderMap1', settings);
                $("#layer_map_wrap").addClass('active');
                break;
            case 'map2':
                $("#layer_map_wrap").fadeIn();
                var con = $('.layer-map-2').clone(true);
                $('#mapBox').append(con);
                var swiper2 = new Swiper('#layer_map_wrap .sliderMap2', settings);
                $("#layer_map_wrap").addClass('active');
                break;
            case 'map3':
                $("#layer_map_wrap").fadeIn();
                var con = $('.layer-map-3').clone(true);
                $('#mapBox').append(con);
                var swiper3 = new Swiper('#layer_map_wrap .sliderMap3', settings);
                $("#layer_map_wrap").addClass('active');
                break;
            case 'map4':
                $("#layer_map_wrap").fadeIn();
                var con = $('.layer-map-4').clone(true);
                $('#mapBox').append(con);
                var swiper4 = new Swiper('#layer_map_wrap .sliderMap4', settings);
                $("#layer_map_wrap").addClass('active');
                break;
            case 'map5':
                $("#layer_map_wrap").fadeIn();
                var con = $('.layer-map-5').clone(true);
                $('#mapBox').append(con);
                var swiper5 = new Swiper('#layer_map_wrap .sliderMap5', settings);
                $("#layer_map_wrap").addClass('active');
                break;
            case 'map6':
                $("#layer_map_wrap").fadeIn();
                var con = $('.layer-map-6').clone(true);
                $('#mapBox').append(con);
                var swiper6 = new Swiper('#layer_map_wrap .sliderMap6', settings);
                $("#layer_map_wrap").addClass('active');
                break;
            case 'map7':
                $("#layer_map_wrap").fadeIn();
                var con = $('.layer-map-7').clone(true);
                $('#mapBox').append(con);
                var swiper7 = new Swiper('#layer_map_wrap .sliderMap7', settings);
                $("#layer_map_wrap").addClass('active');
                break;
            default:
                break;
        }
        $(window).trigger('resize');
    } else if (stateChk == "close") {
        $("#layer_map_wrap").fadeOut().removeClass('active');
        $('#mapBox').empty();
    }
}

let initAnimation = false;

const onStart = () => {

};

const onComplete = () => {

};

const onAnimation = () => {
    $(window).trigger("resize");
    if (!initAnimation) {
        initAnimation = true;
        setMotion();
    }else{
        mm.seek(0);
        mm.pause(0);
    }
    mm.play();
};

const mapInit = () => {
    init();
};

export default {
    onStart,
    onComplete,
    onAnimation,
    mapInit,
};



// WEBPACK FOOTER //
// ./src/js/page/maps.js